import { Component, inject } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { MatTabNav, MatTabLink, MatTabNavPanel } from "@angular/material/tabs";

@Component({
  selector: "app-assignment-home",
  templateUrl: "./assignment-home.component.html",
  styleUrls: ["./assignment-home.component.css"],
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class AssignmentHomeComponent {
  private router = inject(Router);

  activeLink: string = "";

  constructor() {
    const router = this.router;

    router.events.subscribe(() => {
      this.activeLink = router.url;
    });
  }
}
